import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { OverlayService } from '@core';

@Component({
  selector: 'lib-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  imports: [MatButtonModule, RouterLink],
})
export class LogoutComponent {
  readonly overlayService = inject(OverlayService);

  closeOverlay(): void {
    this.overlayService.close();
  }
}
